import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-gradient-to-r from-gray-50 to-gray-100 border-t border-gray-200 py-6 mt-auto">
      <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
        <p className="text-gray-600 text-sm">
          © {currentYear} Maidly Business. All rights reserved.
        </p>
        <Link
          to="/admin/login"
          data-testid="footer-admin-link"
          className="text-xs text-gray-500 hover:text-gray-800 transition-colors"
        >
          Admin
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
